/* SpawnAnything — blob shadows: one instanced, ground-aligned dark disc per unit (used when shadow maps are off).
   One draw call for every unit of both armies; the disc fades and shrinks with the unit's height above ground. */
import * as THREE from 'three';
import { noOutline } from './outlinePass.js';

export function makeBlobShadows(cap) {
  const quad = new THREE.PlaneGeometry(2, 2); quad.rotateX(-Math.PI / 2);
  const g = new THREE.InstancedBufferGeometry();
  g.index = quad.index; g.setAttribute('position', quad.getAttribute('position')); g.setAttribute('uv', quad.getAttribute('uv'));
  const aB = new THREE.InstancedBufferAttribute(new Float32Array(cap * 4), 4); aB.setUsage(THREE.DynamicDrawUsage); // x, groundY, z, radius
  const aF = new THREE.InstancedBufferAttribute(new Float32Array(cap), 1); aF.setUsage(THREE.DynamicDrawUsage); // strength 0..1
  g.setAttribute('aBlob', aB); g.setAttribute('aBlobF', aF); g.instanceCount = 0;
  const mat = new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0.36, depthWrite: false, polygonOffset: true, polygonOffsetFactor: -2, polygonOffsetUnits: -2 });
  mat.onBeforeCompile = sh => {
    sh.vertexShader = sh.vertexShader.replace('void main() {', 'attribute vec4 aBlob; attribute float aBlobF; varying float vBlobF; varying vec2 vBlobUv;\nvoid main() {\nvBlobF = aBlobF; vBlobUv = position.xz;')
      .replace('#include <begin_vertex>', 'vec3 transformed = vec3(position.x * aBlob.w + aBlob.x, aBlob.y + 0.04, position.z * aBlob.w + aBlob.z);');
    sh.fragmentShader = sh.fragmentShader.replace('void main() {', 'varying float vBlobF; varying vec2 vBlobUv;\nvoid main() {')
      .replace('#include <color_fragment>', '#include <color_fragment>\nfloat bd = dot(vBlobUv, vBlobUv); if (bd > 1.0) discard; diffuseColor.a *= vBlobF * (1.0 - smoothstep(0.45, 1.0, bd));');
  };
  mat.customProgramCacheKey = () => 'blob-shadow';
  noOutline(mat);
  const mesh = new THREE.Mesh(g, mat); mesh.frustumCulled = false; mesh.renderOrder = 1;
  let n = 0;
  return {
    mesh, cap,
    begin() { n = 0; },
    /** unit standing at (x, z) on ground height gy with body radius r, feet at height y */
    add(x, gy, z, r, y) {
      if (n >= cap) return;
      const h = Math.max(0, y - gy), f = Math.max(0, 1 - h / (r * 6 + 1)), k = n * 4;
      aB.array[k] = x; aB.array[k + 1] = gy; aB.array[k + 2] = z; aB.array[k + 3] = r * (1.15 - 0.4 * (1 - f));
      aF.array[n++] = f;
    },
    end() {
      g.instanceCount = n; mesh.visible = n > 0;
      if (!n) return;
      aB.clearUpdateRanges(); aB.addUpdateRange(0, n * 4); aB.needsUpdate = true;
      aF.clearUpdateRanges(); aF.addUpdateRange(0, n); aF.needsUpdate = true;
    },
    dispose() { g.dispose(); quad.dispose(); mat.dispose(); },
  };
}
